import { render } from "./ModalVotacionFestivalLasCondes.vue?vue&type=template&id=5832ef22"
import script from "./ModalVotacionFestivalLasCondes.vue?vue&type=script&lang=js"
export * from "./ModalVotacionFestivalLasCondes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__